import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`;
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    margin-top: 4rem;
    align-items: center;
    justify-content: center;

    span {
        margin-top: 4rem;
    }

    h1 {
        font-size: 40px;
        margin-bottom: 5rem;
    }
`;
export const Form = styled.div`
    display: flex;
    width: 90%;
    max-width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .input {
        border: none;
        margin: .5rem 1rem;
        padding: .8rem;
        width: 90%;
        height: 4rem;
        border-radius: 10px;
    }
`;
export const Alert = styled.div``;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    max-width: 800px;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: bold;
    font-size: large;
    background-color: black;
    border-radius: 10px;

    margin: 1rem;

    padding: 1.2rem 1rem;
`;